<script setup lang="ts">
withDefaults(
  defineProps<{
    routeError: string | null;
    routeWarning?: string | null;
    /** No outer card (nested under Route preview). */
    embedded?: boolean;
  }>(),
  { embedded: false },
);
</script>

<template>
  <section
    v-if="!embedded"
    class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm"
  >
    <h2 class="text-sm font-semibold text-gpx_black-200">Routing</h2>
    <p v-if="routeError" class="mt-3 text-xs text-red-700">{{ routeError }}</p>
    <p v-else-if="routeWarning" class="mt-3 text-xs text-amber-800">
      {{ routeWarning }}
    </p>
  </section>
  <div v-else class="border-b border-gray-100 pb-4">
    <p v-if="routeError" class="text-xs text-red-700">{{ routeError }}</p>
    <p v-else-if="routeWarning" class="text-xs text-amber-800">
      {{ routeWarning }}
    </p>
  </div>
</template>
